// extracted by mini-css-extract-plugin
export default {"row":"ForthScreen_row__VI22e","title":"ForthScreen_title__35pUX","icon":"ForthScreen_icon__LTQ4U","more":"ForthScreen_more__rij2Z"};